import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardDetailsComponent } from './components/dashboard-details/dashboard-details.component';
import { extract } from '@app/core';
import { PermissionsGuard } from '@app/core/permissions/permissions.guard';

export const routes: Routes = [
  {
    path: '',
    component: DashboardDetailsComponent,
    data: {
      title: extract('dashboard'),
      breadcrumb: 'dashboard',
      permissionsKeys: [{ key: 'read-dashboard' }]
    },
    canActivate: [PermissionsGuard]
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule {}
